import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Home.scss";

const containerVariant = {
  hide: {
    opacity: 0,
    y: 50,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.5,
      duration: 0.5,
      ease: "linear",
      when: "beforeChildren",
      staggerChildren: 0.3, //delay children animation
    },
  },
  exit: {
    x: "-100vw",
    transition: { ease: "easeInOut", duration: 0.3 },
  },
};

const childVariants = {
  //initial state
  hide: {
    opacity: 0,
    y: 50,
  },
  //animate state
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "linear",
    },
  },
};

const Home = () => {
  return (
    <>
      <motion.section
        className="home"
        variants={containerVariant}
        initial="hide"
        animate="show"
        exit="exit"
      >
        <Link to="/about">
          <FontAwesomeIcon icon={faArrowCircleRight} className="forward-btn" />
        </Link>
        <div className="container">
          <div className="row">
            <div className="col-12 mx-auto p-4 p-md-0">
              <div className="home-content">
                <h6 className="home-h6">Hi, my name is</h6>
                <motion.h1 className="home-h1" variants={childVariants}>
                  Ahmer Altaf.
                </motion.h1>
                <motion.h2 className="home-h2" variants={childVariants}>
                  I'm Front-End Web Developer.
                </motion.h2>
                <motion.h3 className="home-h3" variants={childVariants}>
                  Skills in HTML, CSS/SCSS/TAILWIND, JAVASCRIPT, REACT AND
                  REDUX.
                </motion.h3>
                <motion.div variants={childVariants}>
                  <Link to="/contact">
                    <Button
                      variant="outlined"
                      color="primary"
                      className="home-btn"
                    >
                      Contact me
                    </Button>
                  </Link>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default Home;
